module.exports = __webpack_public_path__ + "img/katarina_outside_7.ffcccb62.jpg";